import React from 'react'

interface VulnerabilityListProps {
  [key: string]: any
}

export const VulnerabilityList: React.FC<VulnerabilityListProps> = (props) => {
  return (
    <div className="p-4 bg-gray-800 rounded-lg">
      <p className="text-gray-400">VulnerabilityList Component - Coming Soon</p>
    </div>
  )
}
